class UnqualifiedReasonReviewer {

    //NOTE: Cannot declare variables at top of class like in Typescript. In plain ES6 JS Microsoft Edge will fail to parse the script (but not other browsers)

    constructor(target) {
        var thisObj = this;

        //Assign elements
        this.target = target;
        this.targetHiddenInput = target.querySelectorAll("input[type=hidden]")[0];
        this.targetButton = target.querySelectorAll("input[type=button]")[0];
            
        //Assign events
        $(this.targetButton).on('click', function () {
            //Toggle the hidden input value
            if (thisObj.targetHiddenInput.value === "True") {
                thisObj.targetHiddenInput.value = "False";
            }
            else {
                thisObj.targetHiddenInput.value = "True";
            }
            thisObj.RefreshDisplay();
        });

        //Call the initial refresh
        this.RefreshDisplay();

        console.log('UnqualifiedReasonReviewer Initialized');
    }

    RefreshDisplay() {
        if (this.targetHiddenInput.value === "True") {
            this.targetButton.value = "Qualified";
            this.targetButton.className = "btn btn-success btn-sm";
        }
        else {
            this.targetButton.value = "Unqualified";
            this.targetButton.className = "btn btn-danger btn-sm";
        }
    }
}

//Instantiate on page load if matching HTML is found
let UnqualifiedReasonReviewerList = [];
$(function () {
    var UnqualifiedReasonReviewersByClass = document.getElementsByClassName("UnqualifiedReasonReviewer");
    for (var i = 0; i < UnqualifiedReasonReviewersByClass.length; i++) {
        UnqualifiedReasonReviewerList.push(new UnqualifiedReasonReviewer(UnqualifiedReasonReviewersByClass.item(i)));
    };
});